import Item from "./Item.js";
import ItemProviders from "./ItemProviders.js";

export default class ItemIniter {
	constructor() {
		this.row = 0;
		this.col = 0;
		this.rownew = 0;
		this.colnew = 0;
		this.id = "";
		this.sheet = "";
		this.name = "";
		this.description = "";
		this.group = "";
		this.level = 1;
		this.type = ItemProviders.TYPE_NONE;
		this.rarity = ItemProviders.RARITY_COMMON;

		this.wearable = false;
		this.material = ItemProviders.MATERIAL_WOOD;

		
		this.weapon = false;
		this.weapon_skill = ItemProviders.WEAPON_SKILL_NONE;
		this.skill_needed = 0;
		this.attack_min = 0;
		this.attack_max = 0;
		this.speed = 0;
		this.armour = false;
		this.armour_class = ItemProviders.ARMOUR_CLASS_NONE;
		this.defense = 0;
		this.set = "";
		this.bonus_damage = 0;
		this.bonus_defense = 0;
		this.bonus_speed = 0;
		this.bonus_skill = 0;
		this.player_skill = ItemProviders.PLAYER_SKILL_NONE;




		this.consumable = false;
		this.edible = false;
		this.cookable = false;
		this.cookskill = 0;
		this.cooktransform = "";
		this.food = 0;
		this.drinkable = false;
		this.water = 0;
		this.heal = 0;

		this.container = false;
		this.slots = 0;

		this.recyclable = false;
		this.charges = -1;

		this.bound = false;
		this.stackable = false;
		this.stacked = 1;
		this.gold = 1;
		this.weight = 0;
		
		this.startItem = false;
		this.startQuantity = 1;
		this.worn = false;
		this.containerPos = -1;
	}

	static alwaysUpdate() {
		return [
			"rownew",
			"colnew",
			"name",
			"description",
			"level",
			"type",
			"rarity",
			"wearable",
			"material",
			"attack_min",
			"attack_max",
			"speed",
			"armour",
			"defense",
			"set",
			"consumable",
			"cookable",
			"cookskill",
			"cooktransform",
			"edible",
			"food",
			"drinkable",
			"drink",
			"heal",
			"container",
			"slots",
			"recyclable",
			"stackable",
			"droppable",
			"gold",
			"weight"
		]
	}

}